/**
 * Formatta una data in formato ISO (YYYY-MM-DD, quella restituita dal backend)
 * nel formato italiano gg/mm/aaaa usato per la visualizzazione nei form.
 */
export function formatIsoDateToItalian(isoDate: string): string {
  if (!isoDate) return '';

  const [yyyy, mm, dd] = isoDate.split('-');
  return `${dd}/${mm}/${yyyy}`;
}

/**
 * Restituisce la data odierna già formattata in gg/mm/aaaa, da usare come
 * valore precompilato nei campi data di sola visualizzazione (es. "Data Creazione").
 */
export function getTodayFormatted(): string {
  const today = new Date();
  const dd = String(today.getDate()).padStart(2, '0');
  const mm = String(today.getMonth() + 1).padStart(2, '0');

  return `${dd}/${mm}/${today.getFullYear()}`;
}
